import React from 'react';
import { Container, Row, Col, CardBody, Card } from 'reactstrap';
import MultiSelectDropdown from '../../common/MultiSelectDropdown';

const MultiSelectDropdownComponent = () => {
    const options = [
        { value: 'Option 1', label: 'Option 1' },
        { value: 'Option 2', label: 'Option 2' },
        { value: 'Option 3', label: 'Option 3' },
        { value: 'Option 4', label: 'Option 4' },
        { value: 'Option 5', label: 'Option 5' },
    ];

    return (
        <div className='page-content components'>
            <Container>
                <Card>
                    <CardBody>
                        <h2 className="mb-4">Multi-Select Dropdown Showcase</h2>

                        {/* First Row */}
                        <Row className="mb-4">
                            <Col lg={6}>
                                <MultiSelectDropdown
                                    label="Select Options"
                                    options={options}
                                    required={true}
                                    defaultSelectedValues={['Option 1', 'Option 2']}
                                    showHelp={true}
                                    helpText="Please select your options."
                                />
                            </Col>
                            <Col lg={6}>
                                <div className="border p-3 rounded" style={{ backgroundColor: '#f8f9fa' }}>
                                    <pre>
                                        {`
<MultiSelectDropdown
    label="Select Options"
    options={options}
    required={true}
    defaultSelectedValues={['Option 1', 'Option 2']}
    showHelp={true}
    helpText="Please select your options."
/>
                                        `}
                                    </pre>
                                </div>
                            </Col>
                        </Row>

                        {/* Second Row */}
                        <Row className="mb-4">
                            <Col lg={6}>
                                <MultiSelectDropdown
                                    label="Limited Selections"
                                    options={options}
                                    required={true}
                                    maxSelections={2}
                                    showHelp={true}
                                    helpText="You can select up to 2 options."
                                />
                            </Col>
                            <Col lg={6}>
                                <div className="border p-3 rounded" style={{ backgroundColor: '#f8f9fa' }}>
                                    <pre>
                                        {`
<MultiSelectDropdown
    label="Limited Selections"
    options={options}
    required={true}
    maxSelections={2}
    showHelp={true}
    helpText="You can select up to 2 options."
/>
                                        `}
                                    </pre>
                                </div>
                            </Col>
                        </Row>

                        {/* Third Row */}
                        <Row className="mb-4">
                            <Col lg={6}>
                                <MultiSelectDropdown
                                    label="Optional Selection"
                                    options={options}
                                    required={false}
                                    showHelp={true}
                                    helpText="This selection is optional."
                                />
                            </Col>
                            <Col lg={6}>
                                <div className="border p-3 rounded" style={{ backgroundColor: '#f8f9fa' }}>
                                    <pre>
                                        {`
<MultiSelectDropdown
    label="Optional Selection"
    options={options}
    required={false}
    showHelp={true}
    helpText="This selection is optional."
/>
                                        `}
                                    </pre>
                                </div>
                            </Col>
                        </Row>

                        {/* Fourth Row */}
                        <Row className="mb-4">
                            <Col lg={6}>
                                <MultiSelectDropdown
                                    label="Clearable Selection"
                                    options={options}
                                    required={true}
                                    isClearable={true}
                                    showHelp={true}
                                    helpText="You can clear your selections."
                                />
                            </Col>
                            <Col lg={6}>
                                <div className="border p-3 rounded" style={{ backgroundColor: '#f8f9fa' }}>
                                    <pre>
                                        {`
<MultiSelectDropdown
    label="Clearable Selection"
    options={options}
    required={true}
    isClearable={true}
    showHelp={true}
    helpText="You can clear your selections."
/>
                                        `}
                                    </pre>
                                </div>
                            </Col>
                        </Row>

                    </CardBody>
                </Card>
            </Container>
        </div>
    );
};

export default MultiSelectDropdownComponent;
